import router from '../router'
import {createAuth}          from '@websanova/vue-auth';
import driverAuthDevise      from '@websanova/vue-auth/dist/drivers/auth/devise.esm.js';
import driverHttpAxios       from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js';
import driverOAuth2Google    from '@websanova/vue-auth/dist/drivers/oauth2/google.esm.js';
import driverOAuth2Facebook  from '@websanova/vue-auth/dist/drivers/oauth2/facebook.esm.js';


export default (app) => {
  app.use(createAuth({
    plugins: {
        http: app.$http,
        router: router
    },
    drivers: {
        http: driverHttpAxios,
        auth: driverAuthDevise,
        router: driverRouterVueRouter,
        oauth2: {
            google: driverOAuth2Google,
            facebook: driverOAuth2Facebook,
        }
    },
    options: {
        rolesKey: 'type',
        notFoundRedirect: {name: 'user-account'},
        loginData: {url: 'auth/sign_in', method: 'POST', redirect: '/', fetchUser: true},
        registerData: {url: 'auth', method: 'POST', redirect: '/login'},
        logoutData: {url: 'auth/sign_out', method: 'DELETE', redirect: '/login', makeRequest: false},
        fetchData: {url: 'auth/validate_token', method: 'GET', enabled: true},
        refreshData: {url: 'user_token/', method: 'GET', enabled: false, interval: 0},
    }
  }));
}
